// import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../../LoadSimple";
import Modal from "react-modal";
import ModalDeleteCis from "../ModalDeleteCis";
import { useState, useEffect } from "react";
import ModalCisAfecta from "../ModalCisAfecta";
import { lang } from "../../generales/traduction";
import { capitalizeFirstLetter } from "../../../utils/utils";
import Action from "../../Action";
import ModalAddHost from "./ModalAddHost";
import ModalAddHostUninstall from "./ModalAddHostUninstall";
import ModalAddHostUpdate from "./ModalAddHostUpdate";
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'80%',
    height:'70%',
    padding:'20px'
  },
};
const CisList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  handleShowPopup,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  cisSelected,
  setCisSelected,
  mode,
  languaje
}) => {
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)

  const [deleteCisModalOpen, setdeleteCisModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({});
  const [CisAfectaModalOpen, setCisAfectaModalOpen] = useState(false);
  const [cisSelectedAux, setCisSelectedAux] = useState([]);
  const [poolRows,setPoolRows]=useState([])
  const [appSelected,setAppSelected]=useState({})
  const [loadingCis,setLoadingCis]=useState(false)
  const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  function openAddHostModal() {
      
    //   console.log('open')
      setAddHostModalOpen(true);
    }

  function closeAddHostModal() {
    setPoolRows([])
      setAddHostModalOpen(false);
  }
  const [addHostModalUninstalOpen, setAddHostUninstalModalOpen] =useState(false);
  function openAddHostUninstalModal() {
      
    //   console.log('open')
    setAddHostUninstalModalOpen(true);
    }

  function closeAddHostUninstalModal() {
    setPoolRows([])
    setAddHostUninstalModalOpen(false);
  }
  const [addHostModalUpdateOpen, setAddHostUpdateModalOpen] =useState(false);
  function openAddHostUpdateModal() {
      
    //   console.log('open')
    setAddHostUpdateModalOpen(true);
    }

  function closeAddHostUpdateModal() {
    setPoolRows([])
    setAddHostUpdateModalOpen(false);
  }
  function openDeleteUserModal() {
    setdeleteCisModalOpen(true);
  }

  function closDeleteCisModal() {
    setdeleteCisModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
    openDeleteUserModal();
    setUserSelected(data);
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  useEffect(() => {
    buscar_cis();
  }, []);
  const buscar_cis = () => {
    setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/provisioning_softwares/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setLoadingCis(false)
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const cisSelectRow = (elemento,type) => {
    setAppSelected(elemento)
    if(type=="IM"){
      openAddHostModal()
    }else if(type=="DM"){
      openAddHostUninstalModal()
    }else if(type=="UM"){
      openAddHostUpdateModal()
    }

    // setCisSelected(elemento);
  };
  function closeCisAfectaModal() {
    setCisAfectaModalOpen(false);
  }

  const openCisAfectaModal = (elemento) => {
    setCisSelectedAux(elemento);
    setCisAfectaModalOpen(true);
  };
  return (
    <>
      <div className="cont-row-user-list">
      
        {loadingCis ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              (elemento.id==8)?'':
              <div
                className={"row-table-portafolio"+mode}
                key={1}
                // onClick={() => cisSelectRow(elemento)}
              >
                 <div className="field-body-table-cis field-larger">
                 <div className="cont-logo-app">
                                <img
                     
                    //  src={"/iconos/appIcon/"+((elemento.icon_name=="")?"workstation.png":elemento.icon_name)}
                    src={"/iconos/appIcon/"+((elemento.software_type_id==1)?elemento.icon_name:((elemento.software_type_id==2)?"workstation.png":"printers.png"))}
                     title="workstation"
                     alt="workstation"
                     name="workstation"
                     // ci_id={cisSelected.element_id}
                     // onClick={openCisAfectaModal}
                     className="iconAppLogo"
                   />
                                </div>
                </div>
                <div className="field-body-table-cis field-medium">
                  {elemento.id}
                </div>
                <div className="field-body-table-cis field-larger" style={{width:'20%'}}>
                  {elemento.name}
                </div>
                <div className="field-body-table-cis field-larger" style={{width:'20%'}}>
                  {elemento.operating_system_name}
                </div>
                <div className="field-body-table-cis field-larger" style={{width:'20%'}}>
                  {elemento.operating_system_version}
                </div>
                <div className="field-body-table-cis field-larger" style={{width:'30%'}}>
                  
                  {
                    (elemento.software_type_id==2)?
                    <div  style={{width:'50%'}}>
                  <Action
                    disabled={false}
                    origen="Azul"
                    titulo={capitalizeFirstLetter(lang[languaje]['actualizacionMasiva'])}
                    action={(e) => {
                      e.stopPropagation();
                      cisSelectRow(elemento,'UM');
                     
                    }}
                  />
                  </div>
                    :
                    <>
                      <div  style={{width:'50%'}}>
                  <Action
                    disabled={false}
                    origen="Azul"
                    titulo={capitalizeFirstLetter(lang[languaje]['installMasiva'])}
                    action={(e) => {
                      e.stopPropagation();
                      cisSelectRow(elemento,'IM');
                     
                    }}
                  />
                  </div>
                  <div  style={{width:'50%'}}>
                  <Action
                    disabled={false}
                    origen="Red"
                    titulo={capitalizeFirstLetter(lang[languaje]['desinstallMasiva'])}
                    action={(e) => {
                      e.stopPropagation();
                      cisSelectRow(elemento,'DM');
                    }}
                  />
                  </div>
                    </>
                  }
                </div>
              </div>
            ))
        )}
        {dataUsers.loading == false && dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}</div>
        ) : (
          ""
        )}
      </div>
      
      <Modal
        isOpen={addHostModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeAddHostModal}
        style={addHostModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalAddHost poolRows={poolRows} server={server} handleShowPopup={handleShowPopup}  appSelected={appSelected} cisSelectRow={cisSelectRow} setPoolRows={setPoolRows} languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalAddHost>
    </Modal>
    <Modal
        isOpen={addHostModalUninstalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeAddHostUninstalModal}
        style={addHostModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalAddHostUninstall poolRows={poolRows} server={server} handleShowPopup={handleShowPopup} appSelected={appSelected} cisSelectRow={cisSelectRow} setPoolRows={setPoolRows} languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostUninstalModal} ></ModalAddHostUninstall>
    </Modal>
    <Modal
        isOpen={addHostModalUpdateOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeAddHostUpdateModal}
        style={addHostModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalAddHostUpdate poolRows={poolRows} server={server} handleShowPopup={handleShowPopup} appSelected={appSelected} cisSelectRow={cisSelectRow} setPoolRows={setPoolRows} languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostUpdateModal} ></ModalAddHostUpdate>
    </Modal>
    </>
  );
};

export default CisList;
